import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

export const TypographyStyled = styled(Typography, {
  name: 'TypographyStyled',
})(({ theme }) => ({
  marginBottom: theme.spacing(1),
  fontWeight: theme.typography.fontWeightBold as number,
}));
